import resetExpressionPickerViewState from '../actions/resetExpressionPickerViewState';
import setExpressionPickerIsOpen from '../actions/setExpressionPickerIsOpen';
import toggleExpressionSidePane from '../actions/toggleExpressionSidePane';
import expressionStore from '../store/expressionStore';
import { lazyHideFlexPane } from 'owa-flex-pane';

export default function closeExpressionPane() {
    let expressionPickerViewState = expressionStore.expressionPickerViewState;
    if (expressionPickerViewState && expressionPickerViewState.isOpen) {
        setExpressionPickerIsOpen(expressionPickerViewState, false);
        resetExpressionPickerViewState();

        if (expressionStore.useFlexPane) {
            lazyHideFlexPane.importAndExecute();
        } else {
            toggleExpressionSidePane(false /* showExpressionPane */);
        }
    }
}
